import React from "react";
import { Typography } from "@material-tailwind/react";

import SocialIcons from "../SocialIcons/SocialIcons";
import "./Contact.css";

const Contact = () => {
  const email = "yuezhengting@gmail.com";

  return (
    <div className="contact-section">
      <div className="contact-content">
        <div className="contact-tech-stack">
          <p className="contact-text">
            Designed in{" "}
            <span className="contact-highlight">Figma</span>,
          </p>
          <p className="contact-text">
            built with{" "}
            <span className="contact-highlight">React.js</span>{" "}
            and{" "}
            <span className="contact-highlight">Material Tailwind</span>,
          </p>
          <p className="contact-text">
            hosted using{" "}
            <span className="contact-highlight">S3</span>,{" "}
            <span className="contact-highlight">Route 53</span>, and{" "}
            <span className="contact-highlight">CloudFront</span>.
          </p>
        </div>

        <div className="contact-cta">
          <Typography variant="h3" className="contact-title">
            Get in touch!
          </Typography>
          <Typography className="contact-message">
            Thank you for taking the time to look at my portfolio.
          </Typography>
          <p className="contact-email-prompt">
            If you would like to get in touch, please feel free to email me at{" "}
            <a
              href={`mailto:${email}`}
              className="contact-email-link"
            >
              {email}
            </a>
            , or connect with me via my socials!
          </p>
        </div>

        <SocialIcons />
      </div>
    </div>
  );
};

export default Contact;
